import CryptoJS from 'crypto-js'
import { JSEncrypt } from 'jsencrypt'

export const encryptCryptoJSData = (key, message) => {
  try {
    const bytes = CryptoJS.AES.encrypt(message, key)
    const decryptData = bytes.toString()
    return decryptData
  } catch (e) {
    return null
  }
}

export const decryptCryptoJSData = (key, message) => {
  try {
    const bytes = CryptoJS.AES.decrypt(message, key)
    const decryptData = bytes.toString(CryptoJS.enc.Utf8)
    return decryptData
  } catch (e) {
    return null
  }
}

export const encryptMessagePublicKey = (message, publicKey) => {
  const jsEncrypt = new JSEncrypt()
  jsEncrypt.setPublicKey(publicKey)
  return jsEncrypt.encrypt(message)
}
